export interface Config {
  applicationName: string;
  apiKey: string;
  apiUrl: string;
  configName: string;
  identityServerUrl: string;
  addressLookupApiKey: string;
}
